import { DEFAULT_CONFIG, SUPPORTED_LOCALES } from "./const";
import { resolveBaseUrl, resolveSource } from "./utils";
export { DEFAULT_CONFIG } from "./const";
export const normalizeLocale = (value) => {
    const locale = String(value || "").toLowerCase();
    return SUPPORTED_LOCALES.includes(locale) ? locale : "en";
};
export const findCurrentScript = () => {
    if (typeof document === "undefined")
        return undefined;
    const current = document.currentScript;
    if (current instanceof HTMLScriptElement)
        return current;
    return undefined;
};
export const resolveConfig = (script = findCurrentScript(), overrides = {}) => {
    var _a;
    const dataset = (_a = script === null || script === void 0 ? void 0 : script.dataset) !== null && _a !== void 0 ? _a : {};
    const scriptConfig = {
        apiBaseUrl: dataset.apiBaseUrl,
        userCenterUrl: dataset.userCenterUrl,
        cookieName: dataset.cookieName,
        temporaryCookieName: dataset.temporaryCookieName,
        source: dataset.source,
        googleClientId: dataset.googleClientId,
        useRequestIdleCallback: dataset.useRequestIdleCallback === "true",
    };
    const runtimeDefaults = Object.assign(Object.assign({}, DEFAULT_CONFIG), { apiBaseUrl: resolveBaseUrl(DEFAULT_CONFIG.apiBaseUrl), userCenterUrl: resolveBaseUrl(DEFAULT_CONFIG.userCenterUrl), source: resolveSource() });
    return Object.assign(Object.assign(Object.assign(Object.assign({}, runtimeDefaults), compact(scriptConfig)), compact(overrides)), { source: resolveSource(overrides.source || scriptConfig.source) });
};
const compact = (value) => Object.fromEntries(Object.entries(value).filter(([, v]) => v !== undefined && v !== ""));
//# sourceMappingURL=config.js.map